import { render, staticRenderFns } from "./StudentTimeTableTable.vue?vue&type=template&id=dbe6d754&scoped=true"
import script from "./StudentTimeTableTable.vue?vue&type=script&lang=js"
export * from "./StudentTimeTableTable.vue?vue&type=script&lang=js"
import style0 from "./StudentTimeTableTable.vue?vue&type=style&index=0&id=dbe6d754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe6d754",
  null
  
)

export default component.exports